import { Filter } from '../../types/main';

export const filtersToObject = (filters?: Filter[], search?: string): { [k: string]: string | string[] | number} => {
  const result: { [k: string]: string | string[] | number} = {};
  if (filters) {
    filters.forEach(({ key, value }) => {
      result[key] = value;
    });
  }

  if (search) {
    result.serach = search;
  }

  return result;
};
